import { Button, KIND, SIZE } from 'baseui/button'
import useZohoButton from '@/containers/SubscriptionFormPageNew/Components/Tools/ZohoButton/useZohoButton'
import logo from '@/containers/SubscriptionFormPageNew/Components/ZohoId/logo.svg'

const ZohoButton = () => {
  const { t, zohoContractId } = useZohoButton()

  if (!zohoContractId) {
    return null
  }

  return (
    <>
      <Button
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={() => window.open(`https://crm.zoho.com/crm/org52021474/tab/CustomModule5/${zohoContractId}`)}
        startEnhancer={() => <img src={logo} alt='Zoho Logo' style={{ width: 24, height: 24 }} />}
      >
        {t('subscriptionForm:zoho_module.link_zoho')}
      </Button>
    </>
  )
}

export default ZohoButton
